<template>
<div id="equestions" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Preguntas" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="modal" width="900" height="600" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="modal = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Responder la Pregunta</strong>
                                        </span>
                                    </v-card>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center>
                                            <h4 class="primary--text" >{{model.modulo}}</h4>
                                            <h5>Pregunta: {{model.pregunta}}</h5>
                                            <p class="text--disabled" >Realizó: {{model.email}}</p>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-textarea outlined rows="3" label="Respuesta" v-model="model.respuesta" :rules="[rules.required]" ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn small @click.native="modal = false" >
                                            <v-icon>cancel</v-icon>Cancelar
                                        </v-btn>
                                        <v-btn color="success" small :loading="loading" @click.native="guardar()" >
                                            <v-icon>done</v-icon>Responder
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>

                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-client-table ref="vuetable" :data="equestions.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="fecha" slot-scope="props" >
                                    {{props.row.fecha!=undefined?props.row.fecha.substring(0,10):''}}
                                </template>
                                <template slot="actions" slot-scope="props" >
                                    <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row)" title="Responder" v-tippy>
                                        <v-icon>email</v-icon>
                                    </v-btn>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {

    data: () => ({

        fab: false,
        URL: "",
        email: "",
        name: "datagrid",
        importData: [],
        columns: ["actions", "fecha", "modulo", "pregunta", "email", "rfc", "respuesta" ],
        show_loading: true,
        title_catalogo: "Administrar Preguntas",
        options: {
            filterable: ["fecha", "modulo", "pregunta", "email", "rfc", "respuesta"],
            sortable: ["fecha", "modulo", "pregunta", "email", "rfc", "respuesta"],

            headings: {
                fecha: "Fecha",
                modulo: "Modulo",
                pregunta: "Pregunta",
                email: "Realizó",
                rfc: "RFC o TAX ID",
                respuesta: "Respuesta",
                actions: "Operaciones"
            }
        },
        columnDefs: null,
        rowData: null,
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/admin"
            },
            {
                text: "Preguntas",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "fecha"
        },
        search: "",
        model: {
            id_question: 0,
            pregunta: "",
            modulo: "",
            fecha: "",
            email: "",
            rfc: "",
            respuesta: "",
            usuario_respuesta: "",
            fecha_respuesta: ""

        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        equestions: {
            selected: [],
            items: [0],

        }
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.equestions.items;
            }
        }
    },
    methods: {

        guardar() {

            this.model.email_respuesta = this.$local_storage.get('email');
            this.model.fecha_respuesta = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            const datos = this.model;
            var res = this.model.email.split(" - ");
            var emails = res[1];

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "PUT";
                var urlCliente =
                    this.URL + "configuracion/equestions/" + this.model.id_question + "/";
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        let datos = "";
                        datos = {
                            sistema: this.$sistema,
                            emails: [emails],
                            asunto: "Econnect - Respuesta a su Pregunta" ,
                            mensaje: "Hola el Equipo de Econnect a respondido su pregunta <br/>Modulo: " + this.model.modulo + "<br/> Pregunta: " + this.model.pregunta + "<br/> Respuesta: " + this.model.respuesta
                        };
                        this.enviaCorreo(datos);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },
        enviaCorreo: async function (datos) {

            console.log(datos);    
            axios.post(this.$hostname + 'correos/enviar/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El correo se envió correctamente",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var errorMsg = "";
                    if (typeof error.response.data != undefined) {
                        for (var k in error.response.data) {
                            for (var j in error.response.data[k])
                                errorMsg += k + ": " + error.response.data[k][j] + "<br/>"
                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al enviar el correo",
                        footer: errorMsg,
                    });
                });
        },
        cargar: function () {
            axios
                .get(this.URL + "configuracion/equestions/")
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        this.equestions.items = res.data;
                        this.equestions.items.sort(function (a, b) {
                            if (a['fecha'] < b['fecha'])
                                return 1;
                            else if (a['fecha'] > b['fecha'])
                                return -1;

                            return 0;
                        });
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (registro) {
            this.model = registro;
            this.modal = true;
        } //getRegistro
    }, //methods
    created: function () {
        this.URL = this.$hostname;
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        this.cargar();
    }
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>